import React from 'react';
import moment from 'moment';

import Table from './Table.component';
import AssetActionsMenu from './AssetActionsMenu';
import EditAssetModal from '../../../containers/assetsOverview/EditAssetModal';

const AssetsTable = ({ tableData, headRows = [], handleDelete, handleEdit, onAccessClick }) => {
  const data = React.useMemo(() => {
    if (tableData) {
      return Object.entries(tableData).map((asset) => asset[1]);
    }
    return [];
  }, [tableData]);

  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [assetToEdit, setAssetToEdit] = React.useState(null);

  // table columns
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        colGroup: 'now',
        sortType: 'basic',
        colGroupClass: 'name text',
        className: 'text target',
        tooltip: 'The name of the asset.',
        Cell: ({ row: { original } }) => (
          <a className="asset-name" href={original.file_url} target="_blank" rel="noopener noreferrer">
            {original.name}
          </a>
        ),
      },
      {
        Header: 'Last Modified By',
        accessor: 'uploaded_by',
        colGroup: 'data',
        colGroupClass: 'goal text',
        className: 'text objective',
        tooltip:
          'The user who most recently modified the asset—whether by uploading it, renaming it, or updating access permissions.',
        Cell: ({ row: { original } }) => <span>{original.uploaded_by || ''}</span>,
      },
      {
        Header: 'Date Modified',
        accessor: 'date_uploaded',
        colGroup: 'data',
        colGroupClass: 'goal text',
        className: 'text objective',
        tooltip: 'The date the asset was last modified.',
        Cell: ({ row: { original } }) => (
          <span>{original.created_at ? moment(original.created_at).format('MM/DD/YYYY hh:mm A') : ''}</span>
        ),
      },
      {
        Header: 'Access',
        accessor: 'access',
        colGroup: 'data',
        colGroupClass: 'goal text',
        className: 'text objective',
        tooltip: 'The list of users who have access to the asset.',
        Cell: ({ row: { original } }) => (
          <span className="access-users" onClick={() => onAccessClick && onAccessClick(original)}>
            {`${original.users_access?.length || 0} ${original.users_access?.length === 1 ? 'user' : 'users'}`}
          </span>
        ),
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => {
          const isFirst = row.visibleIndex === 0;
          const isLast3 = row.visibleIndex >= data.length - 3;
          return (
            <AssetActionsMenu
              asset={row.original}
              onDelete={({ id, name }) => handleDelete({ id, name })}
              onEdit={(asset) => {
                setAssetToEdit(asset);
                setEditModalOpen(true);
              }}
              isUp={isLast3}
              isFirst={isFirst}
            />
          );
        },
        colGroup: 'data',
        colGroupClass: 'goal right text',
        className: 'text right objective',
        disableSortBy: true,
      },
    ],
    [handleDelete, onAccessClick, data],
  );

  // onclick on a row reset the active class
  const hrows = headRows
    .map((row) => {
      if (row) {
        return {
          props: {
            className: 'freeze active',
          },
          columns: [],
        };
      } else return {};
    })
    .filter((anyValue) => typeof anyValue !== 'undefined');

  const initialState = {
    sortBy: React.useMemo(() => [{ id: 'name', desc: false }], []),
  };
  return (
    <>
      <Table data={data} columns={columns} headRows={hrows} initialState={initialState} />
      <EditAssetModal modalOpen={editModalOpen} setModalOpen={setEditModalOpen} asset={assetToEdit} />
    </>
  );
};
export default React.memo(AssetsTable);
